import { render, staticRenderFns } from "./AuthorityDistributeCatalog.vue?vue&type=template&id=650b7447"
import script from "./AuthorityDistributeCatalog.vue?vue&type=script&lang=js"
export * from "./AuthorityDistributeCatalog.vue?vue&type=script&lang=js"
import style0 from "./AuthorityDistributeCatalog.vue?vue&type=style&index=0&id=650b7447&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports